import configureAxios from 'configure/axios';

const axios = configureAxios();

export const getAllocations = (user_profile, page, page_size) => axios.get('cycles/upcoming/', { params: { page, user_profile, page_size } });
export const getAttAllocations = (user_profile, page, page_size) => axios.get('att/cycles/upcoming/', { params: { page, user_profile, page_size } });
export const getQuickAllocations = (user_profile, page, page_size) => axios.get('quick/cycles/upcoming/', { params: { page, user_profile, page_size } });
